import { action } from 'typesafe-actions'

import { GeneralActionTypes } from './types'

export const toggleSide = () => action(GeneralActionTypes.TOGGLE_SIDE)
